import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  progressContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '10px'
  },
  progress: {
    width: '400px',
    height: '5px',
    backgroundColor: palette.shades[200],
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'stretch',
    margin: '0 10px'
  },
  progressPartial: {
    flexGrow: '1',
    height: '5px',
    display: 'inline-block',
    '& + &': {
      marginLeft: '2px'
    },
    '&:first-child': {
      borderRadius: '2px 0 0 2px'
    },
    '&:last-child': {
      borderRadius: '0 2px 2px 0'
    }
  },
  activeStep: {
    backgroundColor: palette.success.main
  },
  unactiveStep: {
    backgroundColor: palette.shades[400]
  }
});
export default useStyles;